<template>
  <div class="bg-white testimonial ">
    <div class="container mx-auto px-3 lg:py-16 py-10">
      <div class="text-center text-primary font-primary font-semibold">Testimonials</div>
      <div class="text-center lg:text-4xl text-2xl font-bold font-primary lg:py-3 py-2">
        What Our Customers Are Saying.
      </div>
      <carousel id="reviews" :pause-autoplay-on-hover="true" :settings="settings" :wrap-around="true"
        :breakpoints="breakpoints" class="lg:py-6 py-3">
        <slide v-for="item in data" :key="item">
          <div class="carousel__item">
            <TestimonialCard :item="item" />
          </div>
        </slide>
        <template #addons class="px-3">
          <Navigation />
          <Pagination />
        </template>
      </carousel>
    </div>
  </div>
</template>
<script setup>
import TestimonialCard from "../../components/cards/TestimonialCard.vue";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Navigation, Slide, Pagination } from "vue3-carousel";
const settings = {
  itemsToShow: 1,
  snapAlign: "center",
  transition: 600,
};
const breakpoints = {
  768: {
    itemsToShow: 2,
    snapAlign: "center",
    autoplay: "5000",
  },
};
const data = [
  {
    description: "These guys are professional, punctual and get the job done. They are also honest, which I particularly appreciate. Wouldn't call any other plumber, highly recommend them.",
    name: "Victor",
    designation: "Client",
  },
  {
    description: "On Time and Professional Service.We had to update our line with a copper 3/4 of an inch pipe and get rid of the old lead pipe at one of our properties we have in the Brampton downtown area.Gill brother Plumbing were great and they cleaned up after their mess.",
    name: "John",
    designation: "Client",
  },
  {
    description: "We got a hot water valve replacement done by Dharwinder . I appreciate the extra time and care he took to answer my questions. Great job! Would definitely come back to Gill brother Plumbing for any future plumbing needs.",
    name: "Michael",
    designation: "Client",
  },
  {
    description: "Every time I called Gill Brother Plumbing I have received quick and excellent service. Very nice plumbers. Always on time and they explain what needs to be done . Prices are good. We won't call any other plumbing service. Thank you for the great service Gill brother plumbing and heating.",
    name: "Cris",
    designation: "Client",
  },
];

</script>
<style scoped>
.testimonial {
  background-image: url("../../assets/v-1.1/testimonial-banner.webp");
  background-position: left bottom;
  background-size: fill;
  background-repeat: no-repeat;

}

.carousel__prev,
.carousel__next {
  background-color: #005CFF !important;
}

.carousel__slide>.carousel__item {
  transform: scale(1);
  opacity: 0.4;
  cursor: pointer;
  display: flex;
  justify-content: center;
  flex-direction: column;
  transition: 0.5s;
  padding: 20px 0;
  margin: 0px 15px;
}

.carousel__slide--visible>.carousel__item {
  opacity: 100;
  width: 100%;
  transform: rotateY(0);

  transform: scale(1.05);
}

/* MEDIA WIDTHS */
/* ======================================= */
@media (max-width: 1536px) {
  .carousel__slide>.carousel__item {
    transform: scale(1);
    opacity: 0.3;
    width: 100%;
    height: auto;
    transition: 0.5s;
  }

  .carousel__slide--visible>.carousel__item {
    opacity: 1;
    width: 110%;
    transform: rotateY(0);
  }
}

@media (max-width: 768px) {
  .carousel__slide>.carousel__item {
    transform: scale(1);
    opacity: 0.3;
    width: 100%;
    transition: 0.5s;
  }

  .carousel__slide--visible>.carousel__item {
    opacity: 1;
    width: 110%;
    height: auto;
    transform: rotateY(0);
  }
}
</style>